(function () {
  window.__PACDORA_STATE__ = window.__PACDORA_STATE__ || {
    initialized: false,
    initializing: false,
    blocked: false,
    blockReason: ""
  };

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function buildSupportEmailBody(payload) {
    var lines = [
      "Hello,",
      "",
      "I would like a custom quote for the following product.",
      "",
      "Product: " + payload.productTitle,
      "Product URL: " + payload.productUrl,
      "Model ID: " + payload.modelId,
      "Name: " + payload.name,
      "Email: " + payload.email,
      "",
      "Delivery country / region:",
      payload.deliveryCountry,
      "",
      "Delivery address:",
      payload.deliveryAddress,
      "",
      "Quantity: " + payload.quantity,
      "",
      "Product to be carried inside:",
      payload.description
    ];

    if (payload.projectId) {
      lines.splice(7, 0, "Project ID: " + payload.projectId);
    }

    if (payload.quotationSummary) {
      lines.push("", "Configuration (from Pacdora):", payload.quotationSummary);
    }

    return lines.join("\n");
  }

  function openSupportEmail(supportEmail, payload) {
    var subject = "Custom quote request: " + payload.productTitle;
    var body = buildSupportEmailBody(payload);
    var maxLen = 1700;
    if (encodeURIComponent(body).length > maxLen) {
      body =
        body.slice(0, Math.floor(maxLen * 0.85)) +
        "\n\n[Message was shortened — see product URL above for context.]";
    }
    var href =
      "mailto:" +
      encodeURIComponent(supportEmail) +
      "?subject=" +
      encodeURIComponent(subject) +
      "&body=" +
      encodeURIComponent(body);
    window.location.href = href;
  }

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showViewerMessage(message) {
    var viewer = document.getElementById("pacdora-viewer");
    if (!viewer) return;
    viewer.innerHTML = '<div style="padding:12px;color:#b91c1c;font-size:14px;">' + message + "</div>";
  }

  var pacdoraPagehideLangBound = false;

  function restorePacdoraShopifyHtmlLang() {
    if (window.__pacdoraPrevHtmlLang === undefined) return;
    var prev = window.__pacdoraPrevHtmlLang;
    window.__pacdoraPrevHtmlLang = undefined;
    window.__pacdoraUiLangApplied = false;
    if (prev === null || prev === "") {
      document.documentElement.removeAttribute("lang");
    } else {
      document.documentElement.setAttribute("lang", prev);
    }
  }

  function bindPacdoraLangRestoreOnLeave() {
    if (pacdoraPagehideLangBound) return;
    pacdoraPagehideLangBound = true;
    window.addEventListener("pagehide", function () {
      restorePacdoraShopifyHtmlLang();
    });
  }

  /**
   * Pacdora SDK resolves editor strings using document.documentElement.lang when
   * i.language is unset (typical Turkish Shopify themes use lang="tr").
   * It also honors sessionStorage pacdora:language + pacdora:language-switch during init.
   * Call again before openAdvancedEditor in case theme scripts reset <html lang>.
   */
  function preparePacdoraEnglishUi() {
    var root = document.querySelector(".pacdora-integration-viewer");
    if (root && root.getAttribute("data-pacdora-preserve-html-lang") === "true") {
      return;
    }
    if (!window.__pacdoraLangHookBound) {
      window.__pacdoraLangHookBound = true;
      bindPacdoraLangRestoreOnLeave();
    }
    if (window.__pacdoraPrevHtmlLang === undefined) {
      window.__pacdoraPrevHtmlLang = document.documentElement.getAttribute("lang");
    }
    window.__pacdoraUiLangApplied = true;
    document.documentElement.setAttribute("lang", "en-US");
    try {
      sessionStorage.setItem("pacdora:language-switch", "true");
      sessionStorage.setItem("pacdora:language", "en-US");
    } catch (e) {
      /* private mode or blocked storage */
    }
  }

  async function initPacdoraViewer(modelId, appId, templateId) {
    if (!window.Pacdora || !modelId || !appId) return null;
    if (window.__PACDORA_STATE__.initializing || window.__PACDORA_STATE__.initialized) return null;

    window.__PACDORA_STATE__.initializing = true;

    try {
      preparePacdoraEnglishUi();

      var viewer = document.getElementById("pacdora-viewer");
      if (viewer) {
        viewer.innerHTML = '<div class="pac-loading"></div>';
      }

      await window.Pacdora.init({
        appId: String(appId),
        isDelay: true,
        quotation: true
      });

      if (!window.Pacdora.createScene) {
        window.__PACDORA_STATE__.initializing = false;
        return null;
      }

      var sceneConfig = {
        modelId: String(modelId),
        isShowLoading: true,
        isCreatePreview: false,
        advancedSetting: {},
        sliderConfig: {
          enabled: true,
          position: "top",
          showSlider: true
        }
      };

      if (templateId) {
        sceneConfig.templateId = String(templateId);
      }

      // Clear again just in case
      if (viewer) viewer.innerHTML = "";

      var projectId = await window.Pacdora.createScene(sceneConfig);
      
      window.__PACDORA_STATE__.initialized = true;
      window.__PACDORA_STATE__.initializing = false;

      // Force a resize event to ensure the 3D canvas fills the container correctly
      setTimeout(function() {
        window.dispatchEvent(new Event('resize'));
        if (window.Pacdora && window.Pacdora.resize) {
           window.Pacdora.resize();
        }
      }, 500);

      // Pacdora events
      if (window.Pacdora.$on) {
        window.Pacdora.$on('advancedDesign:closed', function () {
          setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
            if (window.Pacdora && window.Pacdora.resize) {
              window.Pacdora.resize();
            }
          }, 150);
        });
      }

      return projectId;
    } catch (err) {
      restorePacdoraShopifyHtmlLang();
      window.__PACDORA_STATE__.initializing = false;
      var message = err && err.message ? err.message : String(err || "");
      console.error("Pacdora initialization failed:", message);

      if (message.indexOf("Illegal AppID") !== -1 || message.indexOf("Account unavailable") !== -1) {
        window.__PACDORA_STATE__.blocked = true;
        window.__PACDORA_STATE__.blockReason = "Pacdora account is not authorized for this domain.";
        showViewerMessage("Pacdora is not authorized for this domain. Please match AppID/domain in support.");
      }

      return null;
    }
  }

  async function getQuotationSummaryForEmail() {
    if (!window.Pacdora || typeof window.Pacdora.getQuotationData !== "function") {
      return "";
    }
    try {
      var data = await window.Pacdora.getQuotationData();
      if (!data || !data.advancedData || !data.advancedData.length) return "";
      var parts = [];
      data.advancedData.forEach(function (item) {
        parts.push(item.title + ": " + item.value);
      });
      return parts.join("\n");
    } catch (e) {
      console.warn("Quotation data fetch failed", e);
      return "";
    }
  }

  var _pacdoraEditorClosing = false;
  var _pacdoraCloseListenerAdded = false;

  function removePacdoraEditorElements() {
    var editor = document.querySelector('.pacdora-advanced-design-editor');
    if (editor && editor.parentNode) editor.parentNode.removeChild(editor);
    var mask = document.querySelector('.pacdora-advanced-design-editor-mask');
    if (mask && mask.parentNode) mask.parentNode.removeChild(mask);
    document.body.style.overflow = '';
    document.body.style.overflowY = '';
    setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
      if (window.Pacdora && window.Pacdora.resize) window.Pacdora.resize();
    }, 150);
  }

  ready(function () {
    if (window.__PACDORA_STATE__.blocked) {
      showViewerMessage("Pacdora is temporarily unavailable.");
      return;
    }

    var wrapperViewer = document.querySelector(".pacdora-integration-viewer[data-pacdora-enabled='true']");
    var wrapperForm = document.querySelector(".pacdora-integration-form");
    if (!wrapperViewer && !wrapperForm) return;

    var modelId = (wrapperViewer || wrapperForm).getAttribute("data-pacdora-model-id") || "";
    var templateId = wrapperViewer ? wrapperViewer.getAttribute("data-pacdora-template-id") : "";
    var appId = wrapperViewer ? wrapperViewer.getAttribute("data-pacdora-app-id") : "145b1672d3b8c445";
    var productTitle = wrapperForm ? wrapperForm.getAttribute("data-pacdora-product-title") : "Product";
    var productUrl = wrapperForm ? wrapperForm.getAttribute("data-pacdora-product-url") : window.location.href;
    var supportEmail =
      (wrapperForm && wrapperForm.getAttribute("data-pacdora-support-email")) || "support@varolpack.com";
    var currentProjectId = "";

    // Switch functionality (CSS translateX approach - same as WooCommerce)
    var viewerSlider = document.getElementById("pacdora-viewer-slider");
    var switchBtns = document.querySelectorAll(".pacdora-switch-btn");
    switchBtns.forEach(function(btn) {
      btn.addEventListener("click", function() {
        var type = btn.getAttribute("data-switch");
        switchBtns.forEach(function(b) { b.classList.remove("active"); });
        btn.classList.add("active");
        
        if (viewerSlider) {
          if (type === "3d") {
            viewerSlider.style.transform = "translateX(0)";
          } else if (type === "dieline") {
            viewerSlider.style.transform = "translateX(-100%)";
          }
          setTimeout(function() { window.dispatchEvent(new Event('resize')); }, 50);
        }
      });
    });

    var openBtn = document.querySelector("[data-pacdora-open-modal]");
    var modal = document.querySelector("[data-pacdora-modal]");
    var closeBtn = modal ? modal.querySelector("[data-pacdora-close-modal]") : null;
    var sendBtn = modal ? modal.querySelector("[data-pacdora-send-support]") : null;

    var nameInput = document.getElementById("pacdora-wa-name");
    var emailInput = document.getElementById("pacdora-wa-email");
    var deliveryCountryInput = document.getElementById("pacdora-wa-delivery-country");
    var deliveryAddressInput = document.getElementById("pacdora-wa-delivery-address");
    var quantityInput = document.getElementById("pacdora-wa-quantity");
    var descriptionInput = document.getElementById("pacdora-wa-description");

    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      modal.classList.add("active");
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove("active");
      modal.hidden = true;
    }

    if (openBtn) openBtn.addEventListener("click", openModal);
    if (closeBtn) closeBtn.addEventListener("click", closeModal);

    var advancedDesignBtn = document.querySelector("[data-pacdora-advanced-design]");
    if (advancedDesignBtn) {
      advancedDesignBtn.addEventListener("click", function (e) {
        e.preventDefault();
        if (!window.Pacdora) {
          alert("Design tools are still loading. Please wait a moment and try again.");
          return;
        }
        if (!window.__PACDORA_STATE__.initialized) {
          alert("Design tools are still loading. Please wait a moment and try again.");
          return;
        }
        if (typeof window.Pacdora.openAdvancedEditor !== "function") {
          alert("Online designer is not available. Please refresh the page or try another browser.");
          return;
        }
        try {
          preparePacdoraEnglishUi();

          if (window.Pacdora.$on && !_pacdoraCloseListenerAdded) {
            _pacdoraCloseListenerAdded = true;
            window.Pacdora.$on('advancedDesign:closed', function () {
              if (!_pacdoraEditorClosing) return;
              _pacdoraEditorClosing = false;
              setTimeout(removePacdoraEditorElements, 300);
            });
          }

          var _saveBtnWatcher = setInterval(function () {
            var saveBtn = document.querySelector('.pacdora-advanced-design-editor .save-btn');
            if (saveBtn && !saveBtn._pacCloseBound) {
              saveBtn._pacCloseBound = true;
              saveBtn.addEventListener('click', function () {
                _pacdoraEditorClosing = true;
                setTimeout(function () {
                  if (_pacdoraEditorClosing) {
                    _pacdoraEditorClosing = false;
                    removePacdoraEditorElements();
                  }
                }, 3000);
              });
              clearInterval(_saveBtnWatcher);
            }
          }, 200);

          window.Pacdora.openAdvancedEditor(
            function () {},
            function () {},
            {
              pacdoraId: "design",
              showSide: false,
              saveScreenshot: false,
              screenshotWidth: 800
            }
          );
        } catch (err) {
          console.error("openAdvancedEditor error:", err);
          alert("Could not open the designer. Please try again.");
        }
      });
    }
    if (modal) {
      modal.addEventListener("click", function (event) {
        if (event.target === modal) closeModal();
      });
    }

    if (sendBtn) {
      sendBtn.addEventListener("click", async function () {
        var quotationSummary = await getQuotationSummaryForEmail();

        var payload = {
          productTitle: productTitle,
          productUrl: productUrl,
          modelId: modelId,
          projectId: currentProjectId,
          name: (nameInput && nameInput.value || "").trim(),
          email: (emailInput && emailInput.value || "").trim(),
          deliveryCountry: (deliveryCountryInput && deliveryCountryInput.value || "").trim(),
          deliveryAddress: (deliveryAddressInput && deliveryAddressInput.value || "").trim(),
          quantity: (quantityInput && quantityInput.value || "").trim(),
          description: (descriptionInput && descriptionInput.value || "").trim(),
          quotationSummary: quotationSummary
        };

        if (!payload.name) {
          alert("Please enter your full name.");
          return;
        }
        if (!payload.email || !validateEmail(payload.email)) {
          alert("Please enter a valid email address.");
          return;
        }
        if (!payload.deliveryCountry) {
          alert("Please select your country or region.");
          return;
        }
        if (!payload.deliveryAddress) {
          alert("Please enter your delivery address.");
          return;
        }
        if (!payload.quantity || Number(payload.quantity) <= 0) {
          alert("Please enter a valid quantity.");
          return;
        }
        if (!payload.description) {
          alert("Please describe the product to be carried inside.");
          return;
        }

        openSupportEmail(supportEmail, payload);
        closeModal();
      });
    }

    // Pacdora SDK initialization
    var tries = 0;
    var maxTries = 20;
    var interval = setInterval(async function () {
      tries += 1;
      if (window.Pacdora) {
        if (!window.__PACDORA_STATE__.initialized && !window.__PACDORA_STATE__.blocked) {
          currentProjectId = await initPacdoraViewer(modelId, appId, templateId);
        }
        clearInterval(interval);
      } else if (tries >= maxTries) {
        clearInterval(interval);
      }
    }, 500);
  });
})();

